module.exports = __webpack_public_path__ + "img/light.f1ad0201.svg";